<template>
<widget title="Setup Progress" :widget-spinner="widgetSpinner" :max-height="maxHeight">

	<template slot="header">
		<button class="btn btn-success" v-on:click="$emit('hideWidget')">
			<i class="fa fa-check"></i>
			I'm Done
		</button>
	</template>
		
	<div class="d-flex flex-row justify-content-between setup-item">
		<div>Setup Task</div>
		<div></div>
		<div>Status</div>
	</div>
	<div v-for="(item,index) in setupItems" class="setup-item d-flex flex-row justify-content-between">

		<div v-if="index != activeInfoIndex" style="flex-basis: 210px;margin-right: 10px;"><router-link :to="item.link">{{item.label}}</router-link></div>
		<div style="flex-grow: 1">
			<i v-if="index != activeInfoIndex" class="fa fa-info-circle text-info icon-button" v-on:click="activeInfoIndex = index"></i>
			<alert v-if="index == activeInfoIndex" 
				classes="alert-info" 
				:visible="index == activeInfoIndex"
				v-on:close="activeInfoIndex = -1">

				<h5>{{item.label}}</h5>

				<p>{{item.info}}</p>

				<div class="float-right">
					<router-link class='btn btn-light' :to="item.link">Take me there</router-link>
				</div>
				<div style="clear: both;"></div>

			</alert>
		</div>
		<div v-if="index != activeInfoIndex">
			<i v-if="'key' in item && setupSectionIsComplete(item.key) || 'done' in item && item.done" class="fa fa-check-circle text-success" style="font-size: 16pt;"></i>
			<router-link v-else :to="item.link">Let's do it</router-link>
		</div>
	</div>

</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Alert from "@/components/Alert"
import OnboardingMixins from "@/mixins/OnboardingMixins.js"	

export default {
	name: "SetupProgressWidget",
	components: {
		Widget,
		Alert
	},
	props: ["maxHeight"],
	mixins: [OnboardingMixins],
	data() {
		return {
			activeInfoIndex: -1,
			widgetSpinner: true,
			setupItems: [
				{
					endpoint: "Company/find/"+this.$store.userDetails.tenant_id,
					params: {fields:["image_id"]},
					label: "Add your company logo",
					link: "/company/details",
					done: false,
					info: "Uploading a logo to your company profile makes for more nicely branded invoices and a better company profile"
				},
				{
					label: "Time Log Settings",
					link: "/settings/payroll-settings",
					key: "timeLogSettings",
					info: this.$store.appName+" needs to know when your payroll starts and how often, so it can group Time Logs together appropriately."
				},
				{
					label: "Employee Classifications",
					link: "/settings/employee-classifications",
					key: "employeeClassifications",
					info: "Employee Classifications allow you to set differing pay rates and cost values for different types of employees. This is important for calculating labour costing on projects, as well as for payroll purposes."
				},
				{
					endpoint: "User/get",
					params: {limit: 25,fields:["id"],filters:[["id !=",this.$store.userDetails.id]]},
					label: "Employees Invited",
					link: "/find",
					key: "employeesInvited",
					info: "You can invite existing "+this.$store.appName+" users to join your company, or add user accounts directly"
				},
				{
					endpoint: "Union/get",
					params: {limit: 1,fields:["id"]},
					label: "Compensation Group/Union set up",
					link: "/settings/compensation-groups-unions",
					done: false,
					key: "unionSetup",
					info: "Allows you to set up work terms for union employees (mileage pay, per diems, special pay rates, etc)"
				},
				{
					endpoint: "JobPersonnelRole/get",
					params: {limit: 1,fields:["id"]},
					label: "Job Personnel Roles",
					link: "/settings/personnel-roles",
					done: false,
					key: "personnelRoles",
					info: "Create specific personnel roles that you can assign to people working on Projects and Services (ie. Project Managers, Foremen, Estimators, etc)"
				},
				{
					endpoint: "EmployeeClassification/get",
					params: {limit: 1,fields:["id"]},
					label: "Classifications Created",
					link: "/settings/employee-classifications",
					done: false,
					key: "employeeClassifications",
					info: "Create your list of job classifications that determines default pay rates and union membership"
				},
				{
					params: {limit: 1,fields:["id"]},
					label: "Revenue Codes",
					link: "/settings/revenue-codes",
					key: "revenueCodes",
					info: "Setting up revenue codes for projects and services enables more specific financial reporting"
				},
				{
					params: {limit: 1,fields:["id"]},
					label: "Expense Groups & Codes",
					link: "/settings/expense-codes",
					key: "expenseCodes",
					info: "Setting up expense groups and codes allows expenses to be categorized at the point of entry, which will keep your bookkeeper happy"
				},
				{
					endpoint: "PayBoost/get",
					params: {limit: 1,fields:["id"]},
					label: "Pay Adjustments",
					link: "/settings/pay-adjustments",
					//done: false,
					key: "payAdjustments",
					info: "Pay Adjustments allow you to modify the pay rate for an employee for a specific time log. For example if you have premium pay rates for off-hours work, a Pay Adjustment allows an employee to claim an adjusted rate on a one-off basis"
				},
				{
					endpoint: "ClassificationGroup/get",
					params: {limit: 1,fields:["id"]},
					label: "Invoicing Charge Out Groups",
					link: "/settings/charge-out-groups",
					done: false,
					key: "classificationGroups",
					info: "Often you may need to bill out multiple job classifications at a single rate. Setting up Charge Out Groups allows you to assign multiple classifications to a single group, and set a default billing rate for that group. Billing rates for charge out groups can also be over-ridden per customer in Contact invoice settings."
				}/*,
				{
					endpoint: "JobFileTag/get",
					params: {limit: 1,fields:["id"]},
					label: "Project File Tags Personalized",
					link: "/job-settings/job-file-tags",
					done: false,
					info: "Project Files Tags can be personalized to help you organize your Project specific files how you want."
				}*/
			]
		}
	},
	methods: {
		showInfo(item) {
			this.infoDialog.visible = true

			this.infoDialog.title = item.label
			this.infoDialog.info = item.info
		},
		checkResults(response,requiredLength) {
			if (!requiredLength)
				requiredLength = 1

			if (response.success && response.data.length >= requiredLength)
				return true

			else
				return false
		},
		fetchProgressItems() {
			let vm = this

			this.widgetSpinner = true

			let promises = []

			this.setupItems.forEach(item => {
				if ('endpoint' in item)
					promises.push(this.getJSON(item.endpoint,item.params))
			})

			Promise.all(promises).then(responses => {
				vm.widgetSpinner = false

				responses.forEach((response,index) => {
					if (index == 0) {
						if (response.success && response.data.image_id > 0)
							vm.setupItems[index].done = true
					}
					else if (index == 2) {
						//special handling for TimeLogSetting
						if (response.success && response.data.length > 0 && response.data[0].updated_by > 0)
							vm.setupItems[index].done = true
					}
					else 
						vm.setupItems[index].done = vm.checkResults(response)
				})

			})
		}
	},
	created() {
		this.fetchProgressItems()
	}

}
</script>

<style type="text/css" scoped>
	table.table td, table.table th {
		border: none;
		
	}

	.setup-item {
		border-top: 1px solid #e0e0e0;
		padding: 3px;
	}

</style>